import { css } from '@emotion/css';
import { m } from '@snapchat/snap-design-system-marketing';

export const inputContainerCss = css`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  padding: ${m('--spacing-xs')} ${m('--spacing-m')};
  width: 100%;
`;

export const inputFieldCss = css`
  align-items: center;
  background: ${m('--neutral-v0')};
  border: ${m('--border-width-xs')} solid ${m('--neutral-v250')};
  border-radius: ${m('--border-radius-m')};
  display: flex;
  gap: ${m('--spacing-m')};
  padding: ${m('--spacing-xs')};
  padding-inline-start: ${m('--spacing-s')};
  width: 100%;
`;

export const textareaCss = css`
  background: transparent;
  border: none;
  color: ${m('--neutral-v700')};
  flex: 1;
  font-family: inherit;
  font-size: ${m('--p3-mobile-font-size')};
  font-weight: 500;
  line-height: ${m('--p3-mobile-font-line-height')};
  margin: 0;
  outline: none;
  overflow-y: hidden;
  padding: 0;
  resize: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  &::placeholder {
    color: ${m('--neutral-v400')};
  }
`;

export const sendButtonCss = css`
  && {
    align-items: center;
    background: none;
    border: none;
    border-radius: 0;
    cursor: pointer;
    display: flex;
    flex-shrink: 0;
    height: 28px;
    justify-content: center;
    line-height: 0;
    margin: 0;
    min-height: unset;
    min-width: unset;
    overflow: hidden;
    padding: 0;
    width: 28px;

    svg {
      height: 21px;
      width: 21px;
    }

    &:hover {
      background: none;
      border: none;
      transform: none;
    }

    &:disabled {
      background: none;
      cursor: default;
      opacity: 0.4;
    }
  }
`;

export const sendIconDisabledCss = css`
  color: ${m('--neutral-v300')};
`;
